import React from 'react';
import styled from '@emotion/styled';
import {
	ArrowButton,
	ArrowLink,
	ArrowLinkButton,
	Button,
	ButtonWrap,
	LinkButton,
	TagButton,
	TagButtonWrap,
	TextButton,
} from '../../../ui';
import { getGradientBackground } from '../../shared/styles';

// eslint-disable-next-line no-alert
const sayHello = () => alert('hello');

const ButtonSection = styled.div<{}>`
	margin: 40px 0;

	${ButtonWrap} {
		padding-bottom: 24px;

		&:last-of-type {
			padding-bottom: 0;
		}
	}
`;

const DarkBackgroundButtonSection = styled(ButtonSection)`
	padding: 20px;
	${getGradientBackground('blue-blue')}

	p {
		color: #fff;
	}
`;

export const Buttons = () => (
	<>
		<h2 id="button">Buttons</h2>

		<p>
			<b>Inline Text Button:</b>
			<TextButton variant="highlight">Text Button</TextButton>
			<TextButton variant="highlight" disabled>
				Text Button (disabled)
			</TextButton>
		</p>

		<ButtonSection>
			<ButtonWrap>
				<Button onClick={sayHello}>Primary Button</Button>
				<Button secondary onClick={sayHello}>
					Secondary Button
				</Button>
				<Button onClick={sayHello} disabled>
					Primary Button (disabled)
				</Button>
				<Button secondary disabled onClick={sayHello}>
					Secondary Button (disabled)
				</Button>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowButton onClick={sayHello}>Arrow Button</ArrowButton>
				<ArrowButton secondary onClick={sayHello}>
					Secondary Arrow Button
				</ArrowButton>
				<ArrowButton disabled onClick={sayHello}>
					Arrow Button (disabled)
				</ArrowButton>
				<ArrowButton secondary disabled onClick={sayHello}>
					Secondary Arrow Button (disabled)
				</ArrowButton>
			</ButtonWrap>

			<ButtonWrap>
				<LinkButton href="/">Button Link Internal</LinkButton>
				<LinkButton
					secondary
					href="http://www.google.com"
					target="_blank"
					rel="noopener"
				>
					Secondary Button Link External
				</LinkButton>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowLink href="/">Arrow Link Internal</ArrowLink>
				<ArrowLink href="http://www.google.com" target="_blank" rel="noopener">
					Arrow Link External
				</ArrowLink>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowLinkButton href="/">Primary Arrow Link Internal</ArrowLinkButton>
				<ArrowLinkButton
					secondary
					href="http://www.google.com"
					target="_blank"
					rel="noopener"
				>
					Secondary Arrow Link Button External
				</ArrowLinkButton>
			</ButtonWrap>

			<TagButtonWrap>
				<TagButton>Tag Button</TagButton>
				<TagButton active>Tag Button (active)</TagButton>
				<TagButton disabled>Tag Button (disabled)</TagButton>
				<TagButton active disabled>
					Tag Button (active & disabled)
				</TagButton>
			</TagButtonWrap>
		</ButtonSection>
		<DarkBackgroundButtonSection>
			<p>
				<b>Inline Text Button:</b>
				<TextButton variant="inverted">Text Button</TextButton>
				<TextButton variant="inverted" disabled>
					Text Button (disabled)
				</TextButton>
			</p>

			<ButtonWrap>
				<Button inverted onClick={sayHello}>
					Primary Button
				</Button>
				<Button inverted secondary onClick={sayHello}>
					Secondary Button
				</Button>
				<Button inverted disabled onClick={sayHello}>
					Primary Button (disabled)
				</Button>
				<Button inverted secondary disabled onClick={sayHello}>
					Secondary Button (disabled)
				</Button>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowButton inverted onClick={sayHello}>
					Arrow Button
				</ArrowButton>
				<ArrowButton inverted secondary onClick={sayHello}>
					Secondary Arrow Button
				</ArrowButton>
			</ButtonWrap>

			<ButtonWrap>
				<LinkButton inverted href="/">
					Button Link Internal
				</LinkButton>
				<LinkButton
					inverted
					href="http://www.google.com"
					target="_blank"
					rel="noopener"
					secondary
				>
					Secondary Button Link External
				</LinkButton>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowLink inverted href="/">
					Arrow Link Internal
				</ArrowLink>
				<ArrowLink
					inverted
					href="http://www.google.com"
					target="_blank"
					rel="noopener"
				>
					Arrow Link External
				</ArrowLink>
			</ButtonWrap>

			<ButtonWrap>
				<ArrowLinkButton inverted href="/">
					Primary Arrow Link Internal
				</ArrowLinkButton>
				<ArrowLinkButton
					inverted
					secondary
					href="http://www.google.com"
					target="_blank"
					rel="noopener"
				>
					Secondary Arrow Link Button External
				</ArrowLinkButton>
			</ButtonWrap>
		</DarkBackgroundButtonSection>
	</>
);
